module.exports = __webpack_public_path__ + "static/media/refer.4f9384b2.png";